var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTinyScreen = function SvgTinyScreen(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27.1 27.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Shape1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shapePath1",
    d: "M15.7,15.7 L22.2,15.7 L22.2,17.4 L18.7,17.4 L24.8,23.5 L23.6,24.7 L17.5,18.7 L17.5,22.2 L15.8,22.2 L15.7,15.7 M15.8,4.8 L17.5,4.8 L17.5,8.3 L23.6,2.2 L24.8,3.4 L18.8,9.5 L22.3,9.5 L22.3,11.3 L15.8,11.3 M11.5,11.3 L5,11.3 L5,9.5 L8.5,9.5 L2.4,3.4 L3.6,2.2 L9.7,8.3 L9.7,4.8 L11.4,4.8 L11.5,11.3 M9.7,22.2 L9.7,18.8 L3.6,24.8 L2.4,23.6 L8.5,17.6 L5,17.5 L5,15.7 L11.5,15.7 L11.5,22.2 L9.7,22.2 ",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  })));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTinyScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tiny_screen.57a6413d.svg";
export { ForwardRef as ReactComponent };